import qivaIconUrl from '@/assets/qiva-icon.svg'
import qivaIconDarkUrl from '@/assets/qiva-icon-dark.svg'
import qivaLogoUrl from '@/assets/qiva-logo.svg'
import qivaLogoDarkUrl from '@/assets/qiva-logo-dark.svg'
import { cn } from '@/lib/utils'

const SOURCES = {
  icon: { light: qivaIconUrl, dark: qivaIconDarkUrl },
  full: { light: qivaLogoUrl, dark: qivaLogoDarkUrl },
}

interface BrandLogoProps {
  variant: 'icon' | 'full'
  className?: string
}

export function SidebarLogo({ collapsed }: { collapsed: boolean }) {
  return collapsed
    ? <BrandLogo variant="icon" className="h-auto w-8" />
    : <BrandLogo variant="full" className="h-8 w-auto" />
}

export function BrandLogo({ variant, className }: BrandLogoProps) {
  const { light, dark } = SOURCES[variant]
  return (
    <>
      <img src={light} alt="Qiva" className={cn(className, 'dark:hidden')} />
      <img src={dark} alt="Qiva" className={cn(className, 'hidden dark:block')} />
    </>
  )
}
